module.exports = __webpack_public_path__ + "static/media/loading-logo.3539cf29.png";